import { render, staticRenderFns } from "./customJobDescription.vue?vue&type=template&id=054a92fd&scoped=true"
import script from "./customJobDescription.vue?vue&type=script&lang=js"
export * from "./customJobDescription.vue?vue&type=script&lang=js"
import style0 from "./customJobDescription.vue?vue&type=style&index=0&id=054a92fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a92fd",
  null
  
)

export default component.exports